/**
 * ProtectedRoute.js - 인증이 필요한 라우트 보호 컴포넌트
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { checkAuthStatus, clearAuthData } from '../utils/auth';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const location = useLocation();
  
  // 토큰 유효성 검증을 포함한 로그인 상태 확인
  const isAuthenticated = checkAuthStatus();

  if (!isAuthenticated) {
    // 로그인하지 않았거나 토큰이 만료된 경우 로그인 페이지로 리다이렉트
    // 이전 위치를 저장하여 로그인 후 복귀 가능하도록 함
    clearAuthData(); // 만료된 토큰 데이터 정리
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 권한 체크 (requiredRole이 지정된 경우)
  if (requiredRole && Array.isArray(requiredRole)) {
    const userRole = localStorage.getItem('userRole') || 'user';
    const hasPermission = requiredRole.some(role => 
      role.toLowerCase() === userRole.toLowerCase() || 
      (role.toLowerCase() === 'admin' && userRole.toLowerCase() === 'root')
    );
    
    if (!hasPermission) {
      // 권한이 없는 경우 대시보드로 리다이렉트
      const isMobileView = typeof document !== 'undefined' && document.body.classList.contains('mobile-view');
      const redirectPath = isMobileView ? '/m/dashboard' : '/p/dashboard';
      return <Navigate to={redirectPath} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;

